import classNames from 'classnames';
import React from 'react';
import { Loader } from '../../Templates/Loader/Loader';
import './button.scss';
import { ButtonClassic } from './ButtonClassic';
import { ButtonLink } from './ButtonLink';

enum ButtonClassType {
    Standard = 'Button-standard',
    Search = 'Button-search',
    DarkOutlined = 'Button-dark-outlined',
    Outlined = 'Button-outlined',
    ExportOutlined = 'Button-exportOutlined',
    DownloadOutlined = 'Button-downloadOutlined',
    Danger = 'Button-danger',
    WithoutBorder = 'Button-withoutBorder',
    Login = 'Button-login',
    Underlined = 'Button-underlined',
    TableOrder = 'Button-tableOrder',

    DeleteDialog = 'Button-deleteDialog',
    CancelDialog = 'Button-cancelDialog',
    SaveDialog = 'Button-saveDialog',
}

export interface ButtonProps {
    icon?: React.ReactElement;
    title?: React.ReactNode;
    variant: ButtonClassType;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    loading?: boolean;
    disabled?: boolean;
    type?: 'submit' | 'reset' | 'button';
    isBusy?: boolean;
    link?: string;
    visible?: boolean;
    iconOnRightSide?: boolean;
}

const Button = ({
    title = '',
    icon,
    variant,
    className,
    onClick,
    disabled = false,
    type,
    isBusy,
    link,
    visible = true,
    iconOnRightSide = false,
}: ButtonProps) => {
    const getContent = (): React.ReactNode => (
        <div className="Button-content">
            {iconOnRightSide ? (
                <>
                    <div
                        className={classNames({
                            'Button-title': true,
                            [variant]: variant,
                            'Button-busy': isBusy,
                        })}
                    >
                        {isBusy ? <Loader /> : title}
                    </div>
                    {icon && !isBusy && <div className="Button-icon">{icon}</div>}
                </>
            ) : (
                <>
                    {icon && !isBusy && <div className="Button-icon">{icon}</div>}
                    <div
                        className={classNames({
                            'Button-title': true,
                            [variant]: variant,
                            'Button-busy': isBusy,
                        })}
                    >
                        {isBusy ? <Loader /> : title}
                    </div>
                </>
            )}
        </div>
    );

    if (!visible) {
        return null;
    }

    return link ? (
        <ButtonLink
            className={className}
            link={link}
            getContent={getContent}
            variant={variant}
            disabled={disabled}
        />
    ) : (
        <ButtonClassic
            className={className}
            onClick={onClick}
            getContent={getContent}
            variant={variant}
            type={type}
            disabled={disabled}
        />
    );
};

export { Button, ButtonClassType };
